const CREATED = 'CREATED' as const
const WAITING_ON_DATA = 'WAITING_ON_DATA' as const
const READY_TO_PROCESS = 'READY_TO_PROCESS' as const
const VALIDATING = 'VALIDATING' as const
const PROCESSING = 'PROCESSING' as const
const INDEXING = 'INDEXING' as const
const AWAITING_APPROVAL = 'AWAITING_APPROVAL' as const
const APPROVED = 'APPROVED' as const
const REJECTED = 'REJECTED' as const
const GENERATING_STATICS = 'GENERATING_STATICS' as const
const SENDING_TO_OUTSTREAMS = 'SENDING_TO_OUTSTREAMS' as const
const WAITING_ON_OUTSTREAMS = 'WAITING_ON_OUTSTREAMS' as const
const COMPLETED = 'COMPLETED' as const

export const datasetPhases = {
  CREATED,
  WAITING_ON_DATA,
  READY_TO_PROCESS,
  VALIDATING,
  PROCESSING,
  AWAITING_APPROVAL,
  APPROVED,
  REJECTED,
  GENERATING_STATICS,
  INDEXING,
  SENDING_TO_OUTSTREAMS,
  WAITING_ON_OUTSTREAMS,
  COMPLETED,
} as const
